import React from 'react';
import { HeaderWrapper, RightSection } from './LeftAlignedHeader.styles';

export type LeftAlignedHeaderProps = {
  logo: React.ReactNode;
  rightItems?: React.ReactNode[];
};

export const LeftAlignedHeader: React.FC<LeftAlignedHeaderProps> = ({ logo, rightItems = [] }) => {
  return (
    <HeaderWrapper>
      {logo}
      <RightSection>
        {rightItems.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </RightSection>
    </HeaderWrapper>
  );
};
